import { getContactFirstName } from '@payaca/helpers/contactNameHelper';

/**
 * Build the default intro/outro for the draft-send email body from the
 * Account's email copy setting, substituting the same tokens as the legacy
 * send flow. Falls back to a minimal greeting when no copy is configured.
 */
export const buildDefaultEmailCopy = (params: {
  template: string;
  recipientName: string | null | undefined;
  reference: string;
  companyName: string;
  /** Names the document in the no-template fallback copy, e.g. 'quote'. */
  documentNoun: string;
}): { intro: string; outro: string } => {
  const { template, recipientName, reference, companyName, documentNoun } =
    params;
  const firstName = getContactFirstName(recipientName) || 'customer';

  if (!template) {
    return {
      intro: `Dear ${firstName},\nYour ${documentNoun} can be viewed here:`,
      outro: `Thanks,\n${companyName}`,
    };
  }

  const substituted = template
    .replaceAll('[customer_name]', recipientName ?? '')
    .replaceAll('[customer_first_name]', firstName)
    .replaceAll('[reference]', reference)
    .replaceAll('[company_name]', companyName);

  const [intro, outro] = substituted.includes('\n[button]\n')
    ? substituted.split('\n[button]\n')
    : substituted.split('[button]');

  return { intro: intro ?? '', outro: outro ?? '' };
};
